import { AcademicLevel, CampaignId,  Consentement, Email, FirstName, LastName, MobilePhoneRequired, WishedProgramm } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...CampaignId,
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...WishedProgramm,
  }),
})

export default schema
